import images from "./images";


const team = [
    {
        id: 1,
        image: images.team1,
        name: "David Miller",
        title: "Installation Specialist",
        biography: "David Miller is a dedicated installation specialist committed to ensuring the quality and durability of our windows and doors. His expertise lies in providing top-notch installation services tailored to meet the unique needs of our clients. Lorem ipsum dolor sit amet consectetur adipisicing elit. Lorem ipsum dolor sit amet consectetur adipisicing elit. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Ad libero error repellendus sequi fugit, cum incidunt reiciendis quia porro ex ipsum aut quisquam magnam maxime exercitationem iure commodi labore pariatur.",
        contacts: {
            phone: "111-222-3344",
            email: "david.miller@gmail.com",
            office: "Room 204, Installation Department, Main Office Building"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Installation Technician - Installation Office #5",
            "Quality Assurance Specialist",
            "Customization Expert",
            "Customer Satisfaction Manager"
        ],
        skills: [
            { id: 1, title: "Window Installation", progress: 95 },
            { id: 2, title: "Door Installation", progress: 90 },
            { id: 3, title: "Customization", progress: 85 }
        ]
    },
    {
        id: 2,
        image: images.team2,
        name: "Sophia Clark",
        title: "Installation Expert",
        biography: "Sophia Clark is a seasoned installation expert with a strong reputation for precision and reliability. She excels in executing flawless installations of windows and doors, always focusing on client satisfaction and lasting results. Her experience spans a wide range of residential and commercial projects, where she ensures quality craftsmanship and attention to detail.",
        contacts: {
            phone: "222-333-4455",
            email: "sophia.clark@example.com",
            office: "Office 3B, Residential Installations Wing, North Building"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Lead Installer - Residential Projects",
            "Commercial Door Specialist",
            "Custom Fit Consultant",
            "Site Supervisor"
        ],
        skills: [
            { id: 1, title: "Window Installation", progress: 92 },
            { id: 2, title: "Door Installation", progress: 94 },
            { id: 3, title: "Project Supervision", progress: 88 }
        ]
    },
    {
        id: 3,
        image: images.team3,
        name: "Michael Johnson",
        title: "Installation Technician",
        biography: "Michael Johnson is a reliable installation technician with hands-on experience in setting up a variety of window and door systems. Known for his attention to detail and commitment to safety standards, Michael ensures each installation is done right the first time. He takes pride in delivering exceptional service and customized solutions for every client.",
        contacts: {
            phone: "333-444-5566",
            email: "michael.johnson@example.com",
            office: "Unit 2A, Installation Services Department, East Wing"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Junior Installer",
            "Field Technician",
            "Safety Compliance Officer",
            "Client Service Liaison"
        ],
        skills: [
            { id: 1, title: "Window Installation", progress: 90 },
            { id: 2, title: "Door Installation", progress: 87 },
            { id: 3, title: "Client Communication", progress: 80 }
        ]
    },
    {
        id: 4,
        image: images.team4,
        name: "Emma Watson",
        title: "Installation Expert",
        biography: "Emma Watson is a seasoned installation expert known for her precision, professionalism, and problem-solving approach. With years of experience handling complex installation projects, she ensures each window and door is fitted seamlessly and securely. Emma takes pride in exceeding client expectations and delivering tailored installation solutions.",
        contacts: {
            phone: "444-555-6677",
            email: "emma.watson@example.com",
            office: "Main Office, West Installation Division, Level 3"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Senior Installer",
            "Installation Supervisor",
            "Customization Specialist",
            "Quality Control Inspector"
        ],
        skills: [
            { id: 1, title: "Window Installation", progress: 94 },
            { id: 2, title: "Door Installation", progress: 91 },
            { id: 3, title: "Project Coordination", progress: 88 }
        ]
    }

];

export default team;